module.exports = __webpack_public_path__ + "img/icon_myExchange.971d3908.png";